const tabRootDefaultStyle = theme => {
  const style = {
    '&.MuiTabs-root': {
      position: 'relative',
      borderBottom: `1px solid ${theme.tokens.SemColorBorderDefault}`,
      paddingLeft: '8px',
      paddingRight: '8px',
      '& > div > div': {
        gap: '8px'
      },
      '&::before': {
        content: "''",
        height: '0px',
        background: `${theme.tokens.SemColorOnSurfaceDefault}`,
        width: '8px',
        position: 'absolute',
        left: '8px',
        bottom: '0px'
      },
      '& .MuiTabs-indicator': {
        background: `${theme.tokens.ComponentTabsIndicatorColor} !important`
      }
    }
  };
  return style;
};
export default tabRootDefaultStyle;